import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

export const Callback = () => {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');
      const authSuccess = urlParams.get('auth_success');
      const authError = urlParams.get('auth_error');
      
      // Handle auth errors from backend
      if (authError) {
        console.error('Auth error:', authError);
        setLocation('/login?error=' + authError);
        return;
      }
      
      // Handle OAuth errors
      if (error) {
        console.error('OAuth error:', error);
        setLocation('/login?error=' + error);
        return;
      }
      
      // Handle successful auth from backend redirect
      if (authSuccess === 'true') {
        setLocation('/dashboard');
        return;
      }
      
      // Handle OAuth callback with code and state
      if (code && state) {
        try {
          // The backend callback is already handling this via server-side redirect
          // This code path should not be reached since the server handles /callback
          // But if we do get here, just wait for the redirect
        } catch (err) {
          console.error('Callback error:', err);
          setLocation('/login?error=callback_failed');
        }
      }
    };
    
    handleCallback();
  }, [setLocation]);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-gray-600">{t('login.authenticating')}</p>
      </div>
    </div>
  );
};

export default Callback;